module.exports = __webpack_public_path__ + "67e4210d810e5c7d6af93ab7e199d15f.svg";